/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Usha        10/01/2020      2416: Flow to NLP change
CHID-2     Usha        17/02/2020      2560: 400 Bad Request Issue with gemtriageapi-qa3 POST GemTriage/UpdateTriageLogSymptoms
*********************************************************************************/
import { Component, Helmet, Link, Redirect, renderRoutes } from "@mna/react";
import { azureConfig } from "client.config";
import ErrorModal from "features/ErrorModal";
import Layout from "features/Layout";
import moment from "moment/moment.js";
import { I18nextProvider, Trans } from "react-i18next";
import Modal from "react-modal";
import { pageMap } from "../dynamic/pages.bundle";
import i18n from "../i18n";
import { backClick } from "../pages/find-care-options/questions/Single";
import careOptionsSteps from "../pages/find-care-options/steps";
import * as appState from "../state";
import { enCounterToken } from "../../src/state/triage/actions/utils"
import createLayout from "./layout";
import meta from "./meta";
import TelemetryProvider from "./telemetry-provider";
import { getAppInsights } from "./TelemetryService";
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import Error from "../pages/error"
import i18next from 'i18next';
import { checkAndGetLocalStorageValue, checkAndGetSessionStorageValue, gtag } from "../features/utils";
import { careOptions, telemedicineVendors, commonConstant } from "../server/triage/constants";
import { defaultOrganizationId, gaMeasurementID } from "client.config";
import initState from "../state/azure/initState";

import {
	IsChromeWithAndroid,
	startWorkaroundForChromeMobile,
	stopWorkaroundForChromeMobile,
} from "./workaroundForChromeMobile";

var isQuestionPageCalled = false;
var associatedUri;
var orgId;
var shouldLoaderbeLoaded = false;

const status = {
	Approved: "Approved",
	Denied: "Denied",
};
class App extends Component {
	static serverAction = () => { };
	static getDerivedStateFromError(err) {
		console.log("getDerivedStateFromError", err);
		return { hasError: true, derivedError: err };
	}
	async componentDidMount() {
		const { store, history } = this.props;
		const { state, setState, actions } = store;
		setState({
			isLoading: true,
			screenLoaded: false,
			isStartPageValidationStarted: false,
			isTriageGoingForRegularUser: false
		});
		var currentUrl = window.location.pathname;
		if (currentUrl === "/terms") {
			setState({
				isTriageGoingForRegularUser: true,
			});
		} else {
			setState({
				isTriageGoingForRegularUser: false,
			})
		}
		window.addEventListener("popstate", this.onBackButtonEvent);
		store.actions.createAzureClient({ history });

		window.store = store;
		enCounterToken();
		setState({
			screenLoaded: true,
		});
		const script = document.createElement("script");
		script.src = `https://www.googletagmanager.com/gtag/js?id=${gaMeasurementID}`;
		script.async = true;
		document.body.appendChild(script);
		document.documentElement.setAttribute('lang', 'en');
		gtag('js', new Date());
		var cookiebanner = document.getElementsByClassName("react-cookie-law-dialog");
		if (cookiebanner.length > 0){
			cookiebanner[0].setAttribute('role', 'region');
			cookiebanner[0].setAttribute('aria-label', i18next.t("Cookies.cookieBanner"));
			cookiebanner[0].style.setProperty('overflow-y','auto');
			cookiebanner[0].style.setProperty('max-height','180px');
			cookiebanner[0].addEventListener("keydown", function(e) {
				if(e.key === "Tab"){
					var lastFocusableEl = document.getElementsByClassName("react-cookie-law-accept-btn");
					var firstFocusableEl= document.getElementById("btnDetails");
					if(firstFocusableEl.getAttribute("aria-expanded") === "true" && e.shiftKey && document.activeElement === firstFocusableEl){
						document.getElementById("cookieDetailExp").focus()
                      	e.preventDefault();
					}else if(!e.shiftKey && document.activeElement.className === lastFocusableEl[0].className){
					  e.preventDefault();
					  firstFocusableEl.focus()
					}
				}
			  });
			  var touchRegionElement = document.getElementById('content');
			  var initialX, initialY, initialTime;
			  var lastFocusableEl = document.getElementsByClassName("react-cookie-law-accept-btn");
			  var firstFocusableEl= document.getElementById("btnDetails");
			  touchRegionElement.addEventListener('touchstart', function(e) {
				initialX = e.touches[0].clientX;
				initialY = e.touches[0].clientY;
				initialTime = new Date();
			 });

			 touchRegionElement.addEventListener('touchend', function(e) {
				var deltaX = e.changedTouches[0].clientX - initialX;
				var deltaY = Math.abs(e.changedTouches[0].clientY - initialY);
				var deltaTime = new Date() - initialTime;
			 
				if (deltaX <= -30 && deltaY <= 100 && deltaTime <= 300) {
					//Swipe-left detected
					if(document.activeElement.className === lastFocusableEl[0].className){
						e.preventDefault();
						firstFocusableEl.focus()
					}
				}
				else {
					//Swipe-right detected
					if(firstFocusableEl.getAttribute("aria-expanded") === "true" && document.activeElement === firstFocusableEl){
						document.getElementById("cookieDetailExp").focus()
                      	e.preventDefault();
					}
				}
			 });
			 document.getElementById("content").setAttribute("aria-hidden", "true")
			 document.getElementsByClassName("site-header")[0].setAttribute("aria-hidden", "true")
		}
		var acceptBtn = document.getElementsByClassName("react-cookie-law-accept-btn");
		if (acceptBtn.length > 0)
		{
			acceptBtn[0].setAttribute('role', 'button');
			acceptBtn[0].setAttribute('aria-label', i18next.t("Cookies.acceptButtonText"));
			acceptBtn[0].addEventListener("click", function(e) {
				document.getElementById("content").setAttribute("aria-hidden", "false")
				document.getElementsByClassName("site-header")[0].setAttribute("aria-hidden", "false")
			});
		}

		function navigateTo(path) {
			if (path) {
				history.push(path);
			}
			setTimeout(() => {
				setState({
					isLoading: false,
				});
			}, 1000);
		}

		async function callPolicyCheckApi() {

			const command = "get/contract/details";
			const body = { url: "?partyUri=/persons/" + state.personIdUrl };
			const dataforlng = await actions.postNodeCallBack(state, setState, actions, command, body);
			if (dataforlng && dataforlng.success === commonConstant.true) {
				var currentDate = moment();
				let endDate =
					dataforlng.response.results[0].applicablePeriod
						.endDateTime;
				let startDate =
					dataforlng.response.results[0].applicablePeriod
						.startDateTime;
				let policyNumber =
					dataforlng.response.results[0].externalIdentifiers[0]
						.identifierPropertyValue;
				localStorage.setItem("policyNumber", policyNumber);
				if (
					moment(currentDate).isAfter(startDate) &&
					moment(endDate).isAfter(currentDate)
				) {
					setState({
						PolicyLoad: true,
						PolicyLoadInfo: true,
					});

					actions.organizationCall({ state, actions, setState, shouldLoaderbeLoaded });
					actions.setErrorModal({
						title: <Trans i18nKey="findcareoption.Careoptions.Alert"></Trans>,
						message: <Trans i18nKey="findcareoption.Careoptions.RestrictionMessage"></Trans>,
						comingFrom: commonConstant.orgSubscription,
						setState
					  })
					navigateTo("/terms");
				} else {
					setState({
						PolicyLoad: false,
					});
					if (moment(currentDate).isAfter(endDate)) {
						setState({
							PolicyKey: "ExpiredPolicyKeyMsg",
							PolicyLoadInfo: true,
						});
					}
					if (moment(startDate).isAfter(currentDate)) {
						setState({
							PolicyKey: "FeaturePolicyKeyMsg",
							PolicyKeyDate: moment(startDate).format("YYYY/MM/DD"),
							PolicyLoadInfo: true,
						});
					}
					navigateTo("/check-policy");
				}
			}
		}

		async function getPersonDetailsApi() {
			if (state.azure.user && state.azure.user.localAccountId) {
				const userUrl =
					"?associatedEntityUri=/external-identities?identifyingPropertyKeyValue=" +
					state.azure.user.localAccountId +
					"%26type=Azure AD B2C%26scope=" +
					azureConfig.tenantId;
				const command = "get/person/details";
				const body = { url: userUrl };
				const dataforlng = await actions.postNodeCallBack(state, setState, actions, command, body);
				if (dataforlng && dataforlng.success === commonConstant.true && dataforlng.response.results.length !== 0) {
					var userResponse = dataforlng;
					var contractUrl =
						userResponse.response.results[0].personId +
						"/branches/" +
						userResponse.response.results[0].branch.contextId;
					setState({
						personIdUrl: contractUrl,
					});
					if (userResponse.response.results[0].associatedEntityUris.length !== 0) {
						var organizationwithBranch =
							userResponse.response.results[0].associatedEntityUris[1].targetEntityUri;
						setState({
							orgwithBranchUrl: organizationwithBranch
						});
					}
					localStorage.setItem("gender", userResponse.response.results[0].gender);
					localStorage.setItem("dateOfBirth", userResponse.response.results[0].dateOfBirth);
					callOrgSubscriptionsApi();
				} else {
					setState({
						doNotHavePolicyInfo: true,
						PolicyLoad: false,
					});
					navigateTo("/check-policy");
				}
			}
		}

		async function callOrgSubscriptionsApi() {
			var IsRegularLogin = true;

			var responseStatus = await actions.validateOrganizationApi(
				state,
				setState,
				actions,
				orgId,
				IsRegularLogin
			);
			if (responseStatus) {
				callUserSubscriptionsApi();
			} else {
				actions.setErrorModal({
					title: <Trans i18nKey="findcareoption.Careoptions.Alert"></Trans>,
					message: <Trans i18nKey="findcareoption.Careoptions.RestrictionMessage"></Trans>,
					comingFrom: commonConstant.orgSubscription,
					setState
				})
			}
		}

		async function callUserSubscriptionsApi() {
			var personId = state.personIdUrl;
			const userSubscriptionUrl =
				"?billableItemUri=/billable-items/9c8fcef6-849c-4788-8877-29929fa984bd&subscriberEntityUri=/persons/" +
				personId;
			const command = "get/subcription/details";
			const body = { url: userSubscriptionUrl };
			const subscriptionObject = await actions.postNodeCallBack(state, setState, actions, command, body);
			if (subscriptionObject && subscriptionObject.success === commonConstant.true && subscriptionObject != undefined &&
				subscriptionObject.response.results.length > 0 &&
				subscriptionObject.response.results[0].status ==
				status.Approved) {
				setState({
					IsUserSubscriptionValid: true,
				});
				sessionStorage.setItem("IsUserSubscriptionValid", true);
				callPolicyCheckApi();
			} else {
				setState({
					IsUserSubscriptionValid: false,
				});
				sessionStorage.setItem("IsUserSubscriptionValid", false);
				navigateTo("/check-policy");
			}
		}

		startWorkaroundForChromeMobile();

		setTimeout(async () => {
			var oidValue = checkAndGetLocalStorageValue("oid");
			if (oidValue === "") {
				oidValue = state.oid
			}
			var currentUrl = window.location.pathname;
			if (
				currentUrl !== "/create-profile" &&
				currentUrl !== "/create-user" &&
				currentUrl !== "/create-details" &&
				currentUrl !== "/create-primary"
			) {

				//get the email and set in sessionStorage
				var userEmailLocal = checkAndGetLocalStorageValue("userEmail");
				if (userEmailLocal.length <= 0) {
					if (oidValue) {
						const urlBuilderForIdentyProperties =
							"get/externalIdentities?ExternalIdentityScope=" +
							process.env.AZURE_ADB2C_BASE_SCOPE + "&ExternalIdentityType=Azure AD B2C" +
							"&identifyingPropertyKeyName=objectId&identifyingPropertyKeyValue=";
						const command = urlBuilderForIdentyProperties + oidValue;
						const response = await actions.getNodeCallBack(state, setState, actions, command);
						if (response && response.success === commonConstant.true && response.response.results.length >= 1) {
							var userEmailIdentifier = response.response.results[0].identityProperties.find(t => t.keyName == "identities[0].issuerAssignedId");
							localStorage.setItem("userEmail", userEmailIdentifier.keyValue)
						} else {
							localStorage.setItem("userEmail", "")

						}
					}
				}
				var userSession = sessionStorage.getItem("IsValidUser")
				var userSessionFacility = sessionStorage.getItem("isFacility")
				var userSessionTravelAid = sessionStorage.getItem("isTravelAid2");
				if (oidValue) {
					const urlBuilderForIdentity =
						"get/id?ExternalIdentityScope=" +
						process.env.AZURE_ADB2C_BASE_SCOPE +
						"&externalIdentityIdentifyingPropertyKeyName=objectId&externalIdentityIdentifyingPropertyKeyValue=";
					const command = urlBuilderForIdentity + oidValue;

					const result = await actions.getNodeCallBack(state, setState, actions, command);
					if (result && result.success === commonConstant.true) {
						if (result.response.results.length >= 1) {
							associatedUri =
								result.response.results[0].associatedEntitiesUri[0];
							let organizationIdArray = associatedUri.split("/");
							localStorage.setItem("orgid", organizationIdArray[2]);
							orgId = organizationIdArray[2];
							getPersonDetailsApi();
						} else {
							actions.getOrgImageApi({ state, setState, actions, shouldLoaderbeLoaded });
							if (state.IsValidUser) {
								history.push({
									pathname: "/terms",
									search: "?organizationId=" + checkAndGetLocalStorageValue("orgid"),
								});
							}
							navigateTo();
						}
					} else {
						navigateTo();
					}

				} else if (userSession === "true") {
					if (window.location.pathname !== "/terms") {
						var organizationId = checkAndGetLocalStorageValue("orgid");
						history.push({
							pathname: "/terms",
							search: "?organizationId=" + organizationId,
						});
					}
				}
				else if (userSessionFacility === "true") {
					if (window.location.pathname !== "/find-facility") {
						var organizationId = checkAndGetLocalStorageValue("orgid");
						history.push({
							pathname: "/find-facility",
							search: "?organizationId=" + organizationId,
						});
					}
				}
				// when we reload the screen from any page it should be navigate to base url
				else if (userSessionTravelAid === "true") {
					if (window.location.pathname !== "/triageNew") {
						var organizationId = checkAndGetLocalStorageValue("orgid");
						history.push({
							pathname: "/triageNew",
							search: "?organizationId=" + organizationId,
						});
					}
				}
				else {
					navigateTo();
				}
			} else {
				if (
					currentUrl === "/create-profile" ||
					currentUrl === "/create-user" ||
					currentUrl === "/create-details" ||
					currentUrl === "/create-primary"
				) {
					//5293 For non login user to block navigating to create user flow
					if (checkAndGetSessionStorageValue("IsValidUser") == "true") {
						history.push({
							pathname: "/terms",
							search: "?organizationId=" + checkAndGetLocalStorageValue("orgid"),
						});
					}
					else if (checkAndGetSessionStorageValue("isFacility") == "true") {
						history.push({
							pathname: "/find-facility",
							search: "?organizationId=" + checkAndGetLocalStorageValue("orgid"),
						});
					}
					else {
						sessionStorage.setItem("isPageRefreshed", "false");
						sessionStorage.setItem("LoginSucess", "false");
						localStorage.clear();
						localStorage.setItem("orgid", null);
						localStorage.setItem("token", null);
						actions.setAzureState(initState());
						setState({
							isLoading: false,
						});
					}
				}
			}
		}, 5000);
	}

	componentWillUnmount() {
		stopWorkaroundForChromeMobile();
		window.removeEventListener("popstate", this.onBackButtonEvent);
	}

	componentDidCatch(err, info) {
		console.log(err, info);
	}

	onBackButtonEvent = (e) => {
		e.preventDefault();
		e.stopPropagation();
		const { store, location, history } = this.props;
		const { state, actions, setState } = store;
		if (state.UserNavigatedToQT) {
			setState({
				QuickTeleMedAvailableOrNot: false,
			});
		}
		const pathname = this.state.currentRoute || location.pathname;
		const routeParts = pathname
			.split("/")
			.slice(1)
			.filter((f) => f);
		const routeName = routeParts.join("/");

		const thankYouPath = "find-care-options/thank-you"
		if (routeName === thankYouPath && !state.declineCare) {
			history.push("/find-care-options/thank-you")
		}
		if (routeName === thankYouPath && state.declineCare) {
			history.push({
				pathname: "/find-care-options/thank-you",
				search: "?decline=1",
			});
		}

		if (
			state.presentQuestionsSelected.length > 0 ||
			state.unknownQuestionsSelected.length > 0 ||
			state.absentQuestionsSelected.length > 0
		) {
			if (routeName === "find-care-options/questions") {
				if (typeof window !== "undefined") {
					if (!isQuestionPageCalled) {
						if(sessionStorage.getItem("contolBackButton") !== 'true')
						{
							history.go(1);
						isQuestionPageCalled = true;
						backClick({ state, actions, setState, history });
						setTimeout(() => {
							isQuestionPageCalled = false;
						}, 700);
					}
					}
				} else {
					isQuestionPageCalled = false;
				}
			} else {
				isQuestionPageCalled = false;
			}
		} else {
			if (!isQuestionPageCalled ) {
				if (routeName === "find-care-options/questions") {
					if (state.isTravelAid2) {
						history.push("/find-care-options/symptoms");
					}
					else if (state.RelatedSymptomInfo.length > 0 && sessionStorage.getItem("contolBackButton") !== 'true') {
						history.push("/find-care-options/related-symptoms");
					}
					else if(sessionStorage.getItem("contolBackButton") !== 'true'){
						state.triageRequest.activeMenu = "symptoms"
						history.push("/find-care-options/symptom-priority");
					}
				}
			}
		}
	};

	state = {
		currentRoute: "",
		hasError: false,
		derivedError: '',
		showing: false
	};

	onRouteEnter = (newLocation) => {
		window.onload = function () {
			if (IsChromeWithAndroid()) {
				var isPageRefreshed = sessionStorage.getItem("isPageRefreshed");
				if (isPageRefreshed === null) {
					isPageRefreshed = "false";
					sessionStorage.setItem("isPageRefreshed", isPageRefreshed);
				}
				if (isPageRefreshed === "false") {
					sessionStorage.setItem("isPageRefreshed", "true");
					window.location.reload();
				}
			}
		};

		const currentRoute = newLocation.pathname;
		this.setState({
			currentRoute,
		});
	};
	render() {
		// Catch any error in component tree
		// TODO: Redirect to error screen with more helpful info
		if (this.state.hasError) {
			getAppInsights().trackException({
				error: new Error(this.state.derivedError),
				severityLevel: SeverityLevel.Error
			})
			return <Error />
		}

		const { route, store, location, history } = this.props;
		const { state, actions, setState } = store;

		const pathname = this.state.currentRoute || location.pathname;
		const routeParts = pathname
			.split("/")
			.slice(1)
			.filter((f) => f);
		const routeName = routeParts.join("/");
		const routeBase = routeParts[0] || "";
		const { showing } = this.state;
		//To handle covid api loop
		if (routeName !== "find-care-options/covid") {
			if (typeof window !== "undefined") {
				localStorage.setItem("isCovidPageLoaded", "false");
			}
		}
		if (!routeParts.length) routeParts.push("home");

		const routeClassName = routeParts
			.map((p, index) => `route-${routeParts.slice(0, index + 1).join("-")}`)
			.join(" ");

		let isLoggedIn = state.azure && state.azure.user && state.azure.accessToken;
		isLoggedIn = state.IsValidUser == true || state.isFacility == true ? true : isLoggedIn;
		const isAdmin = isLoggedIn && false;
		let theRoute, backButtonTarget, backButtonStep;

		const routeProps = {
			state,
			actions,
			setState,
			isLoggedIn,
			isAdmin,
		};
		const findCareRouteBase = "find-care-options";

		if (routeBase === findCareRouteBase) {
			// Find route for "previous step" link in header
			let stepName = routeName.split("/")[1] || "start"; // 'welcome'

			// sessionId is created on clicking "Next" from bio section
			const ensureSessionFromBeginning = false;
			if (
				ensureSessionFromBeginning &&
				stepName !== "start" &&
				!state.triageRequest.sessionId
			) {
				theRoute = <Redirect to={`/${findCareRouteBase}`} />;
			} else {
				//690: Pages don't enforce login
				//if not logged in redirecting to get started page.
				if (isLoggedIn != null) {
					const steps = careOptionsSteps;
					let Step = pageMap[`${findCareRouteBase}/${steps[0].name}`]; //steps[0].component // First step is default
					let previousStepName, nextStepName;

					for (let i = 0, len = steps.length - 1; i < len; i++) {
						const { name } = steps[i];
						if (name !== stepName) continue;
						previousStepName = steps[i].previous || (steps[i - 1] || {}).name;
						nextStepName = steps[i].next || (steps[i + 1] || {}).name;
						break;
					}

					var IsEmergencySelected = checkAndGetLocalStorageValue("IsEmergencySelected");
					if (typeof window != "undefined") {
						if (nextStepName == "emergency" && IsEmergencySelected == "true") {
							console.log("IsEmergencySelected " + IsEmergencySelected);
							previousStepName = "emergency-question";
						}
					}
					//CHID-1 Start
					if (i18n.language == "en-US" || i18n.language == "en") {
						state.triageRequest.triageSymptom = "NLP";
					} else {
						state.triageRequest.triageSymptom = "List";
					}
					const symptomPage =
						state.triageRequest.triageSymptom === "List"
							? "symptoms"
							: "NLPsymptom";

					if (
						stepName == "symptom-priority" &&
						typeof symptomPage != "undefined"
					)
					{previousStepName = symptomPage;
						state.triageRequest.activeMenu = "symptoms";
					}
					if (stepName == "location" && typeof symptomPage != "undefined")
						nextStepName = symptomPage;
					if (stepName == "symptoms" || stepName == "NLPsymptom" ) {
						nextStepName = "symptom-priority";
						previousStepName = "location";
					}
					if (stepName == "send-information" && IsEmergencySelected == "true")
						previousStepName = "emergency";
					//CHID-1 End
					theRoute = renderRoutes(route.routes, {
						...routeProps,
						Step,
						previousStepName,
						nextStepName,
					}); // switchProps

					if (previousStepName) {
						if(state.isTravelAid2 && stepName == "care-options"){
							backButtonTarget = `/${findCareRouteBase}/symptoms`;
							backButtonStep = stepName;
						}else{
						backButtonTarget = `/${findCareRouteBase}/${previousStepName}`;
						backButtonStep = stepName;
					}
					}
					if (stepName == "telemedicine-info") {
						{
							previousStepName =
								checkAndGetLocalStorageValue("careoption") == careOptions.Telemedicine &&
									state.triageResponse.selectedConnectionType == "1"
									? "telemed-connectiontype"
									: "telemed-videoprompt";
						}
						backButtonTarget = `/${findCareRouteBase}/${previousStepName}`;
					}

					if (stepName == "care-options-result") {
						{
							previousStepName =
								checkAndGetLocalStorageValue("careoption") == careOptions.Telemedicine
									? "telemed-pharma-prompt"
									: "care-options";
									state.triageRequest.activeMenu = "care-options";

						}
						backButtonTarget = `/${findCareRouteBase}/${previousStepName}`;
					}
					if (stepName == "patientdetails-confo-screen") {
						if (state.isTravelAid2  || checkAndGetLocalStorageValue("IsEmergencySelected") == "true") {
							previousStepName = "send-information";
							backButtonTarget = `/${findCareRouteBase}/${previousStepName}`;
						}else{
							state.triageRequest.activeMenu = "care-options";
						}
						backButtonTarget = `/${findCareRouteBase}/${previousStepName}`;
					}
					if (stepName == "telemed-confirm-screen") {
						{
							checkAndGetLocalStorageValue("careoption") == careOptions.Telemedicine &&
								state.triageResponse.vendorsList[0].nameLocalization
									.localizations[0].value == telemedicineVendors.oneEightHundredMD
								? state.triageRequest.ispharmaselected == true
									? (previousStepName = "care-options-result")
									: (previousStepName = "telemed-pharma-prompt")
								: (previousStepName = "telemedicine-info");
						}
						backButtonTarget = `/${findCareRouteBase}/${previousStepName}`;
					}
					if (stepName == "send-information") {
						{
							checkAndGetLocalStorageValue("careoption") == careOptions.Telemedicine &&
								state.triageResponse.vendorsList[0].nameLocalization
									.localizations[0].value == telemedicineVendors.oneEightHundredMD
								? (previousStepName = "telemed-confirm-screen")
								: checkAndGetLocalStorageValue("careoption") == careOptions.Telemedicine
									? (previousStepName = "telemed-confirm-screen")
									: (previousStepName = "care-options-result");
						}
						backButtonTarget = `/${findCareRouteBase}/${previousStepName}`;
					}
					if (stepName == "telemed-videoprompt") {
						{
							checkAndGetLocalStorageValue("careoption") == careOptions.Telemedicine &&
								(state.triageResponse.vendorsList[0].nameLocalization
									.localizations[0].value == telemedicineVendors.oneEightHundredMD ||
									state.triageResponse.vendorsList[0].nameLocalization
										.localizations[0].value == telemedicineVendors.Semesur)
								? (previousStepName = "telemed-connectiontype")
								: (previousStepName = "care-options");
						}
						backButtonTarget = `/${findCareRouteBase}/${previousStepName}`;
					}
					if (stepName == "telemedicine-result") {
						backButtonTarget = "";
					}
					if (stepName == "concierge-care-result") {
						backButtonTarget = "";
					}
					if (stepName == "house-visit-result") {
						backButtonTarget = "";
					}
				} else {
					history.push("/");
				}
			}
		} else {
			theRoute = renderRoutes(route.routes, routeProps);
		}

		const errorModalState = state.errorModal
			? {
				...state.errorModal,
				isOpen: true,
				history, setState,
				clear: actions.clearErrorModal,
			}
			: { isOpen: false, history, setState };
		let appInsights = null;
		return (
			<TelemetryProvider
				instrumentationKey={azureConfig.instrumentKey}
				after={() => {
					appInsights = getAppInsights();
				}}
			>
				<I18nextProvider i18n={i18n}>
					<div className={routeClassName}>
						<Helmet {...meta}>						
							<meta http-equiv="X-Content-Type-Options" content="nosniff"/>
							<meta http-equiv="Content-Security-Policy" content="script-src 'self' http://localhost:8086/ https://*.globalexcel.com/ https://maps.googleapis.com/ https://www.googletagmanager.com/;"/>
							<meta http-equiv="X-Frame-Options" content="DENY"/> 
							<meta httpEquiv="cache-control" content="no-cache, must-revalidate, max-age=31536000;"/>
							<meta http-equiv="Strict-Transport-Security" content="max-age=31536000; includeSubDomains; preload"/>
						</Helmet>
						<ErrorModal {...errorModalState} />
						<Layout
							{...{
								state,
								actions,
								location,
								history,
								setState,
								menuTitle: <Link to="/">{meta.defaultTitle}</Link>,

								onRouteEnter: this.onRouteEnter,

								...createLayout({
									state,
									actions,
									setState,
									location,
									history,
									isLoggedIn,
									isAdmin,
									routeName,
									routeBase,
									backButtonTarget,
									backButtonStep,
								}),
							}}
						>
							{theRoute}
						</Layout>

						<Modal
							isOpen={state.policyShowModel}
							contentLabel="customStyles"
							className="ReactModal__Content_triagepopup"
							overlayClassName="ReactModal__Overlay_triagepopup"
						>
							<label
								style={{
									color: "#616461",
									fontWeight: "500",
									textTransform: "uppercase",
								}}
							>
								ALERT
							</label>

							<label
								style={{
									color: "#616461",
								}}
							>
								{state.PolicyKey == "ExpiredPolicyKeyMsg" ? (
									<Trans i18nKey="ExpiredPolicyKeyMsg">
										Unfortunately we are unable to verify an active policy with
										the information you have provided{" "}
									</Trans>
								) : (
									<div className="pop_PolicyLabel col-md-12">
										<Trans i18nKey="FeaturePolicyKeyMsg">
											{" "}
											Set up is complete, however your policy activation date is
											on the{" "}
										</Trans>
										<span style={{ fontWeight: "bold" }}>
											{" "}
											{state.PolicyKeyDate}
										</span>
										<Trans i18nKey="FeaturePolicyKeyMsg1">
											{" "}
											, you will be able to use the service then, please contact
											GEM on 1-866-566-1463 for more information{" "}
										</Trans>
									</div>
								)}
							</label>
							<div className="pop_button">
								<button
									style={{ color: "#4ea9fd" }}
									onClick={(e) => {
										e.preventDefault();
										actions.azureLogout(actions, state, history);
										setState({
											showModal: false,
										});
									}}
								>
									<Trans i18nKey="findcareoption.OK">OK</Trans>
								</button>
							</div>
						</Modal>

					</div>


				</I18nextProvider>
			</TelemetryProvider>
		);
	}
}

Object.assign(App, appState);

export default App;
